module.exports = __webpack_public_path__ + "media/public/img/maverick-logo-7325df094f006c293dabca05e5d17ab3.svg";